import { Close as CloseIcon } from '@mui/icons-material';
import { IconButton, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { TenantLogoType } from 'shared/components';

export default function Header({ toggleNav }: { toggleNav: () => void }) {
    const { t } = useTranslation('navigation');

    return (
        <DrawerHeader>
            <TenantLogoType />
            <IconButton color="primary"
                onClick={ toggleNav }
                aria-label={ t('close') }
            >
                <CloseIcon />
            </IconButton>
        </DrawerHeader>
    );
}

const DrawerHeader = styled(Stack)(({ theme }) => ({
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2, 3)
}));
